import React from 'react';
import { Card, CardContent } from '../../ui/card';
import { Button } from '../../ui/button';
import { Input } from '../../ui/input';
import { Badge } from '../../ui/badge';
import { Award, Plus, Trash2 } from 'lucide-react';

const skillSuggestions = [
  'Revit', 'AutoCAD', 'Navisworks', 'BIM 360', 'ArchiCAD',
  'SketchUp', 'Dynamo', 'Coordenação BIM', 'Modelagem 3D',
  'LOD', 'ISO 19650', 'Clash Detection', 'Quantitativos',
  'Famílias Revit', 'MEP', 'Estruturas', 'Arquitetura'
];

export const Step3SkillsCerts = ({
  formData, setFormData, newSkill, setNewSkill,
  handleAddSkill, handleRemoveSkill,
  handleAddCertification, handleUpdateCertification, handleRemoveCertification,
}) => (
  <div className="space-y-8">
    <div className="text-center mb-8">
      <h2 className="text-2xl font-bold text-white mb-2">Habilidades & Certificações</h2>
      <p className="text-gray-400">Mostre suas competências</p>
    </div>

    {/* Skills */}
    <div>
      <label className="block text-sm text-gray-400 mb-3">Habilidades</label>
      <div className="flex flex-wrap gap-2 mb-3">
        {formData.skills.map((skill) => (
          <Badge key={skill} className="bg-blue-600/20 text-blue-400 pr-1">
            {skill}
            <button
              onClick={() => handleRemoveSkill(skill)}
              className="ml-2 hover:text-red-400"
            >
              ×
            </button>
          </Badge>
        ))}
      </div>
      <div className="flex gap-2">
        <Input
          value={newSkill}
          onChange={(e) => setNewSkill(e.target.value)}
          placeholder="Adicionar habilidade"
          className="bg-zinc-800 border-zinc-700 text-white"
          onKeyPress={(e) => e.key === 'Enter' && (e.preventDefault(), handleAddSkill())}
        />
        <Button onClick={handleAddSkill} variant="outline" className="border-zinc-700">
          <Plus className="w-4 h-4" />
        </Button>
      </div>
      <div className="flex flex-wrap gap-2 mt-3">
        <span className="text-xs text-gray-500">Sugestões:</span>
        {skillSuggestions.filter(s => !formData.skills.includes(s)).slice(0, 8).map((skill) => (
          <button
            key={skill}
            onClick={() => setFormData(prev => ({ ...prev, skills: [...prev.skills, skill] }))}
            className="text-xs text-gray-400 hover:text-blue-400 bg-zinc-800 px-2 py-1 rounded"
          >
            + {skill}
          </button>
        ))}
      </div>
    </div>

    {/* Certifications */}
    <div>
      <div className="flex items-center justify-between mb-3">
        <label className="text-sm text-gray-400 flex items-center">
          <Award className="w-4 h-4 mr-2" />
          Certificações
        </label>
        <Button onClick={handleAddCertification} size="sm" variant="outline" className="border-zinc-700">
          <Plus className="w-4 h-4 mr-1" /> Adicionar
        </Button>
      </div>

      {formData.certifications.map((cert, idx) => (
        <Card key={cert._key || idx} className="bg-zinc-800/50 border-zinc-700 mb-3">
          <CardContent className="p-4 space-y-3">
            <div className="flex justify-between">
              <Input
                value={cert.name}
                onChange={(e) => handleUpdateCertification(idx, 'name', e.target.value)}
                placeholder="Nome da certificação"
                className="bg-zinc-800 border-zinc-700 text-white"
              />
              <Button
                variant="ghost"
                size="sm"
                onClick={() => handleRemoveCertification(idx)}
                className="text-red-400 hover:text-red-300"
              >
                <Trash2 className="w-4 h-4" />
              </Button>
            </div>
            <div className="grid grid-cols-2 gap-3">
              <Input
                value={cert.issuer}
                onChange={(e) => handleUpdateCertification(idx, 'issuer', e.target.value)}
                placeholder="Instituição emissora"
                className="bg-zinc-800 border-zinc-700 text-white"
              />
              <Input
                type="month"
                value={cert.issue_date}
                onChange={(e) => handleUpdateCertification(idx, 'issue_date', e.target.value)}
                className="bg-zinc-800 border-zinc-700 text-white"
              />
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  </div>
);

export default Step3SkillsCerts;
